import React, {forwardRef} from 'react'
import LabelIcon from '@material-ui/icons/Label'
import _ from 'lodash'
import {Typography} from '@material-ui/core'

const LeftHandle = forwardRef((props, ref) => {
  const {label} = props
  return (
    <div
      className="disable-drag"
      ref={ref}
      style={{
        display: 'none',
        background: 'rgba(29, 35, 49, 0.15)',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        backdropFilter: 'grayscale(1)',
      }}
      draggable={false}
    >
      <div
        className="disable-drag"
        data-x="date-selection"
        style={{
          borderRight: 'blue solid 2px',
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          width: 5,
          cursor: 'w-resize',
          zIndex: 901,
          pointerEvents: 'all',
        }}
        name="leftHandle"
        draggable={false}
      >
        <div
          style={{
            position: 'sticky',
            top: 0,
            right: 0,
            pointerEvents: 'none',
          }}
        >
          <LabelIcon
            style={{
              transform: 'rotateZ(90deg) translate(-4px, 7px)',
              color: 'blue',
              position: 'absolute',
            }}
          />
          <Typography
            name="label"
            className="ap-typography ap-typography--sm"
            style={{
              color: 'white',
              position: 'absolute',
              width: 80,
              height: 32,
              backgroundColor: '#3473ff',
              padding: 5,
              display: 'flex',
              alignItems: 'center',
              left: -77,
              justifyContent: 'flex-end',
            }}
          >
            {label}
          </Typography>
        </div>
      </div>
      {/* <div
        style={{width: width, left: 0}}
        className={`ap-reservation-gantt-date-time-selector__indicator-left`}
      >
        <div draggable className="left-indicator"></div>
      </div> */}
    </div>
  )
})

export default LeftHandle
